function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "@apollo/client";
import { useNavigation } from "@react-navigation/native";
import { StyleSheet } from "react-native";
import { useI18n } from "../../../lib/i18n";
import { useTheme } from "../../../styles";
import { ChatArtifactPreview } from "../../ChatArtifactPreview";
import { Icon } from "../../Icon";
import { Heading } from "../../Text";
import { View } from "../../View";
import { SessionVideosQuery } from "../Videos/Videos";
var LINK_TEXT_BY_ARTIFACT_NAME = {
    ActivityDiary: 'Activity diary',
    BingeEatingMyPlan: 'MyPlan',
    BreathHolding: 'Breath holding',
    CopingCards: 'Coping cards',
    CrisisFramework: 'Risk curve',
    EatingLog: 'Eating log',
    EditEatingSchedule: 'Eating schedule',
    HopeKit: 'Hope kit',
    Hyperventilation: 'Hyperventilation',
    MyPlanReview: 'MyPlan review',
    Relaxation: 'Relaxation',
    RiskCurve: 'Risk Curve',
    SleepDiary: 'Sleep diary',
    SoloMyPlan: 'MyPlan',
    SoloRiskCurve: 'Risk curve',
    SoloSuicideMode: 'Risk curve',
    StressSensitivityAssessment: 'Stress sensitivity assessment',
    SuicideMode: 'Risk curve',
    ThoughtDiary: 'Thought diary',
    WordPairing: 'Word pairing'
};
/**
 * Renders list of activity previews associated with the provided
 * `contentType`. This is typically the same list of activities as is available
 * through the chatbot content for the corresponding session.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-139}
 */ export function SessionActivities(param) {
    var contentType = param.contentType, testID = param.testID;
    var _data_user_role_sessions__session_content, _data_user_role_sessions_, _data_user_role, _data_user;
    var $t = useI18n().$t;
    var navigate = useNavigation().navigate;
    var _useTheme = useTheme(), theme = _useTheme.theme, Shadow = _useTheme.Shadow;
    var data = useQuery(SessionVideosQuery, {
        variables: {
            contentType: contentType
        },
        fetchPolicy: 'cache-first'
    }).data;
    var activities = data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : (_data_user_role = _data_user.role) === null || _data_user_role === void 0 ? void 0 : (_data_user_role_sessions_ = _data_user_role.sessions[0]) === null || _data_user_role_sessions_ === void 0 ? void 0 : (_data_user_role_sessions__session_content = _data_user_role_sessions_.session.content) === null || _data_user_role_sessions__session_content === void 0 ? void 0 : _data_user_role_sessions__session_content.activities;
    var _activities_length;
    return /*#__PURE__*/ _jsxs(View, {
        testID: testID,
        style: [
            {
                flexDirection: 'column',
                justifyContent: 'space-between'
            }
        ],
        spacing: 15,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                level: 2,
                text: $t({
                    id: 'Conversation_videoTabActivitiesHeadline',
                    defaultMessage: 'Activities'
                })
            }),
            /*#__PURE__*/ _jsxs(View, {
                style: [
                    {
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }
                ],
                children: [
                    activities === null || activities === void 0 ? void 0 : activities.map(function(item) {
                        return /*#__PURE__*/ _jsxs(View, {
                            children: [
                                /*#__PURE__*/ _jsx(ChatArtifactPreview, {
                                    artifactName: item.name,
                                    linkText: LINK_TEXT_BY_ARTIFACT_NAME[item.name],
                                    testID: "ChatArtifactPreview_".concat(item.name),
                                    params: _object_spread({}, item.params),
                                    // @ts-ignore
                                    _onSideEffect: function(param) {
                                        var routeName = param.routeName, params = param.params;
                                        return navigate(routeName, params);
                                    },
                                    _width: 159,
                                    _height: 177,
                                    _borderColor: "transparent"
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread_props(_object_spread({}, StyleSheet.absoluteFillObject), {
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        bottom: 50
                                    }),
                                    pointerEvents: "none",
                                    children: /*#__PURE__*/ _jsx(View, {
                                        style: [
                                            {
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 50,
                                                height: 50,
                                                backgroundColor: 'rgba(255,255,255,1)',
                                                borderRadius: 50 / 2
                                            },
                                            Shadow.high
                                        ],
                                        children: /*#__PURE__*/ _jsx(Icon, {
                                            color: theme.color.primary100,
                                            name: "arrow-right",
                                            size: 30
                                        })
                                    })
                                })
                            ]
                        }, item.name);
                    }),
                    ((_activities_length = activities === null || activities === void 0 ? void 0 : activities.length) !== null && _activities_length !== void 0 ? _activities_length : 0) % 2 === 1 ? /*#__PURE__*/ _jsx(View, {
                        style: {
                            width: 159
                        }
                    }) : null
                ]
            })
        ]
    });
}
